import examineTemplate from '../examineTemplate'
import projectCost from '../projectCost'
import PublicBuill from './publicBuill'
import billTitleTemplate from '../billTitleTemplate'
import invoiceTable from '../invoiceTable'

export default {
  components: {
    examineTemplate,
    billTitleTemplate,
    projectCost,
    invoiceTable
  },
  props: {
    property: Object,
    view: String,
    AccountingReview: Boolean,
    toVoid: Boolean
  },
  data() {
    return {
      show: true,
      title: '吴忠仪表销售有限公司差旅费报销单',
      sale: {},
      ccrq: '',
      lcPersons: ['', '', '', '', '', '', '', '', '', ''], // 流程人员
      text: ['出差报告', '项目跟踪'],
      examineTemplate: {
        workflowData: []
      },
      jhShow: false,
      /* 审核需要数据 */
      oaSqdSh: {
        userNo: localStorage.getItem('userNo'),
        isAgree: '',
        shyj: '',
        documentType: 'xsccbxd0',
        flowId: '',
        maindjh: '',
        lb: 'xsccbxd',
        shr: localStorage.getItem('userName'),
        shrNo: localStorage.getItem('userNo'),
        shje: ''
      },
      oldJe: 0,
      invoiceArr: [],
      invoiceDelArr: [],
      invoiceChange: false
    }
  },
  mounted() {
    this.initData(this.property)
    this.getDiffDay(this.property.cfrq1, this.property.lrrq)
  },
  created() {
    PublicBuill.setThis(this)
  },
  methods: {
    initData(billDataAll) {
      const sale = billDataAll.BillData
      this.oldJe = sale.bxzj
      const examineData = billDataAll.examineData

      this.sale = sale
      if (sale.ccsy === '计划外项目' || sale.ccsy === '计划内项目') {
        this.jhShow = true
      }
      /* 审核使用字段 */
      this.oaSqdSh.maindjh = sale.djh
      this.oaSqdSh.flowId = sale.flowId
      this.oaSqdSh.shje = sale.bxzj

      this.sale.bxzjDx = PublicBuill.convertCurrency(sale.bxzj)
      const jeName = ['fj', 'hc', 'ctqc', 'jt', 'lg', 'xl', 'dh', 'hy', 'qy', 'qt', 'clfxj',
        'bzje1', 'bzje2', 'bzje3', 'bzje4', 'bzxj', 'bxzj']
      for (let i = 0; i < jeName.length; i++) {
        const itemName = jeName[i]
        if (this.sale[itemName] && this.sale[itemName] !== '0.00' && this.sale[itemName] !== '0.0000') {
          this.sale[itemName] = PublicBuill.formatAmount(this.sale[itemName])
        } else {
          this.sale[itemName] = ''
        }
      }

      this.examineTemplate.workflowData = []
      /* 有工作流信息 */
      if (examineData) {
        const oldShName = {
          xsccbxd00:	'商务部长',
          xsccbxd01:	'会计核算',
          xsccbxd02:	'财务审核',
          xsccbxd03: '副总经理',
          xsccbxd04: '财务部长',
          xsccbxd05: '总经理',
          xsccbxd06:	'总会计师',
          xsccbxd07:	'董事长'
        }
        for (let i = 0; i < examineData.length; i++) {
          const val = examineData[i]
          let nodeName = val.lcName
          const liId = val.lcid
          if (!nodeName) {
            nodeName = oldShName[liId]
            val.lcName = nodeName
          }
          if (nodeName === '经办人') {
            val.auditStatus = '提交'
          } else if (val.shbz === '0') {
            val.auditStatus = '退回'
          } else {
            val.auditStatus = '批准'
          }

          const shr = val.shr

          if (nodeName !== '经办人') {
            if (nodeName === '董事长') {
              this.lcPersons[9] = shr
            } else if (nodeName === '总经理') {
              this.lcPersons[8] = shr
            } else if (nodeName === '总会计师') {
              this.lcPersons[7] = shr
            } else if (nodeName === '财务部长') {
              this.lcPersons[6] = shr
            } else if (nodeName === '财务审核') {
              this.lcPersons[5] = shr
            } else if (nodeName === '副总经理') {
              this.lcPersons[4] = shr
            } else if (nodeName === '会计核算') {
              this.lcPersons[3] = shr
            } else if (nodeName === '商务部长') {
              this.lcPersons[2] = shr
            } else if (nodeName === '销售副总审核') {
              this.lcPersons[1] = shr
            }
          }

          if (shr)
            this.examineTemplate.workflowData.push(val)
          if (i === 0 && sale.recipient)
            this.examineTemplate.workflowData.unshift({ shr: sale.recipient, auditStatus: '未办理' })
        }
      }
    },
    agreeClick() {
      PublicBuill.agreeClick()
    },
    refuseClick() {
      PublicBuill.refuseClick()
    },
    queryBillData() {
      this.$emit('queryBillData')
      this.saleClose()
    },
    saleClose() {
      this.show = false
      this.$emit('saleBillClose')
    },
    getDiffDay(date_1, date_2) {
      // 计算两个日期之间的差值
      const myDate_1 = Date.parse(date_1)
      const myDate_2 = Date.parse(date_2)
      // 将两个日期都转换为毫秒格式，然后做差
      const diffDate = Math.abs(myDate_1 - myDate_2) // 取相差毫秒数的绝对值
      return Math.floor(diffDate / (1000 * 3600 * 24)) // 向下取整
    },
    ccsqFormatter(val1, val2, ts) {
      return PublicBuill.ccsqFormatter(val1, val2, ts)
    },
    rqFormatter(val) {
      return PublicBuill.stringSplitSpace(val)
    },
    bzjeFormatter(val) {
      if (Number(val) > 0)
        return val
      else
        return ''
    },
    jeChange() {
      const clf = ['fj', 'hc', 'ctqc', 'jt', 'lg', 'xl', 'dh', 'hy', 'qy', 'qt']
      let je = 0
      for (let i = 0; i < clf.length; i++) {
        const cl = clf[i]
        if (this.sale[cl] !== null && this.sale[cl] !== '' && this.sale[cl] !== undefined) {
          je += parseInt(Number(this.sale[cl].replaceAll(',', ''), 2) * 100)
        }
      }
      this.sale.clfxj = Number(je / 100, 2)
      const as = parseInt(Number(this.sale.bzxj, 2) * 100)
      this.sale.bzxj = Number(as / 100, 2)
      this.sale.bxzj = this.sale.clfxj + this.sale.bzxj
    },
    jeChanges() {
      const bzxj = ['bzje1', 'bzje2', 'bzje3', 'bzje4']
      let bzje = 0
      for (let i = 0; i < bzxj.length; i++) {
        const bz = bzxj[i]
        if (this.sale[bz] !== null && this.sale[bz] !== '' && this.sale[bz] !== undefined) {
          bzje += parseInt(Number(this.sale[bz].replaceAll(',', ''), 2) * 100)
        }
      }
      this.sale.bzxj = Number(bzje / 100, 2)
      this.sale.bxzj = parseInt(this.sale.clfxj) + parseInt(this.sale.bzxj)
      this.jeChange()
    },
    checkSave() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.sale.oldJe = this.oldJe
      this.sale.hsr = localStorage.getItem('userName')
      const jeName = ['fj', 'hc', 'ctqc', 'jt', 'lg', 'xl', 'dh', 'hy', 'qy', 'qt', 'clfxj',
        'bzje1', 'bzje2', 'bzje3', 'bzje4', 'bzxj', 'bxzj']
      for (let i = 0; i < jeName.length; i++) {
        const itemName = jeName[i]
        if (isNaN(Number(this.sale[itemName]))) {
          this.sale[itemName] = this.sale[itemName].replaceAll(',', '')
        }
      }
      this.$post('/fesback/ccbxd/editXsCcbxd.z', this.sale).then(response => {
        if (response.success === true) {
          this.queryBillData()
          this.saleClose()
          this.$message.success('会计核算修改成功!')
          loading.close()
        } else {
          this.$message.error('会计核算修改失败!')
        }
      })
    },
    updateInvoice(val) {
      this.invoiceArr = val
      this.invoiceChange = true
    },
    delInvoice(val) {
      val.forEach(val => {
        this.invoiceDelArr.push(val)
      })
    }
  }
}
